<template>
  <v-card v-if="isPanelOpen" class="ai-assistant-sidebar flex-shrink-0" width="387">
    <ai-assistant-panel :context="context" @close="handleClosePanel" />
  </v-card>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { storeToRefs } from "pinia";
import { useSidebarPanelStore, SidebarId } from "@/_store/sidebar-panel.module.ts";
import { useAppsManagementModule } from "@/_store/apps-mgmt.module.ts";
import AiAssistantPanel from "@/components/ai-assistant/AiAssistantPanel.vue";

export default defineComponent({
  components: {
    AiAssistantPanel,
  },
  setup() {
    const sidebarPanelStore = useSidebarPanelStore();
    const appsManagementModule = useAppsManagementModule();
    const { context } = storeToRefs(appsManagementModule);
    const isPanelOpen = computed(() => sidebarPanelStore.isOpen(SidebarId.AI_ASSISTANT));

    const handleClosePanel = () => {
      sidebarPanelStore.closeSidebar();
    };

    return {
      isPanelOpen,
      context,
      handleClosePanel,
    };
  },
});
</script>

<style lang="scss" scoped>
.ai-assistant-sidebar {
  margin-top: 18px;
  height: calc(100vh - 104px);
  border: 2px solid rgb(var(--v-theme-white));
}
</style>
